import DibbleConfigs from './dibble-config';

const DibbleAPI = {
    endpoint: DibbleConfigs.apiEndpoint,
    downloadUri: DibbleConfigs.downloadInvoiceUri,
    api: {
        login: 'Account/login',
        sendOtpCode: 'Account/login_send_otp_code',
        resendOtpCode: 'Account/login_resend_otp_code',
        verifyOtpCode: 'Account/login_verify_otp_code',
        accountSendOtpCode: 'Account/pending_send_otp_code',
        accountReSendOtpCode: 'Account/pending_resend_otp_code',
        accountVerifyOtpCode: 'Account/pending_verify_otp_code',

        managedUserSendOtpCode: 'ManageUsers/send_otp_code',
        managedUserResendOtpCode: 'ManageUsers/resend_otp_code',
        managedUserVerifyOtpCode: 'ManageUsers/verify_otp_code',

        getCountryCodes: 'General/get_country_phone_codes',
        getStateList: 'General/get_states',
        getCountryList: 'General/get_countries',
        createAccount: 'Account/create_account',
        getMyAccountStatus: 'Account/get_my_account_status',

        getDashboardData: 'General/get_dashboard',
        getMyAuthDetails: 'Account/get_my_auth_details',

        campaignSetStatus: 'Campaign/set_status',
        getDonations: 'Donation/get_by_campaign',
        getAllDonations: 'Donation/get_all',
        donationGetReportUrl: 'Donation/get_report_url',
        donationGetFilters: 'Donation/get_filters',
        manualDonation: 'Donation/manual_donation',
        donationResendReceipt: 'Donation/resend_receipt',
        donationGet: 'Donation/get',
        donationStopTilledSubscription: 'Donation/stop_tilled_subscription',

        getDistributions: 'Distribution/get_all',
        getDistribution: 'Distribution/get',
        createDistribution: 'Distribution/create',
        updateDistribution: 'Distribution/update',
        accountChangeFactor: 'Account/change_factor',
        accountChangeFactorSendOtpCode: 'Account/change_factor_send_otp_code',
        accountChangeFactorReSendOtpCode: 'Account/change_factor_resend_otp_code',
        accountChangeFactorVerifyOtpCode: 'Account/change_factor_verify_otp_code',

        managedUserChangeFactor: 'ManageUsers/change_factor',
        managedUserChangeFactorSendOtpCode: 'ManageUsers/change_factor_send_otp_code',
        managedUserChangeFactorReSendOtpCode: 'ManageUsers/change_factor_resend_otp_code',
        managedUserChangeFactorVerifyOtpCode: 'ManageUsers/change_factor_verify_otp_code',

        distributionGetTemplateUrl: 'Distribution/get_template_url',
        distributionUploadExcel: 'Distribution/upload_excel',
        distributionDistribute: 'Distribution/distribute',

        designationGetAll: 'Designation/get_all',
        designationAdd: 'Designation/add',
        designationUpdate: 'Designation/update',
        designationDelete: 'Designation/delete',
        designationGetDonations: 'Donation/get_by_designation',
        designationGetAllUnPaged: 'Designation/get_all_unpaged',
        campaignGetDesignations: 'Campaign/get_designations',
        campaignSetDesignations: 'Campaign/set_designations',
        campaignGetQuestions: 'Campaign/get_questions',
        campaignSetQuestion: 'Campaign/add_question',
        campaignSetQuestionsOrder: 'Campaign/update_questions_order',
        campaignRemoveQuestion: 'Campaign/delete_question',
        campaignUpdateQuestion: 'Campaign/update_question',


        getUsers: 'ManageUsers/get_users',
        setUserActive: 'ManageUsers/set_user_active',
        resendInvitationToUser: 'ManageUsers/resend_invitation_to_user',
        deleteUser: 'ManageUsers/delete_user',
        createUser: 'ManageUsers/create_user',
        updateUser: 'ManageUsers/update_user',

        /*| Rental |*/
        getRentalBoatsInfo: 'admin_get_rental_boats_info',
        getRentalBoatTypes: 'get_rental_boat_types',
        getRentalBoatOrdersHistory: 'get_rental_boat_orders_history',
        adminGetBoatTypeInfo: 'admin_get_rental_boat_type_info',
        addRentalBoat: 'add_rental_boat',
        addRentalBoatNote: 'add_rental_boat_note',
        updateRentalBoat: 'update_rental_boat',
        validateOrderQrCode: 'validate_order_qr_code',
        adminGetRentalBoatOrder: 'admin_get_rental_boat_order',
        adminChangeBoatOrderStatus: 'admin_set_rental_boat_order_status',
        getRentalBoatExtras: 'get_rental_boat_extras',
        checkoutRentalBoat: 'checkout_rental_boat',
        checkinRentalBoat: 'checkin_rental_boat',
        updateRentalBoatStatus: 'update_rental_boat_status',
        deleteRentalBoat: 'delete_rental_boat',
        cancelRentalBoat: 'cancel_rental_boat',
        getAvailableCheckoutBoats: 'get_available_checkout_boats',
        exportRentalReport: 'export_rental_report',
        rentalSaveDeskCheckingSignature: 'rental_save_desk_checking_signature',
        setNoRentalBoatAddOns: 'set_no_rental_boat_add_ons',
        addOnPayNewCC: 'cc_pay_rental_boat_add_ons',
        addOnPaySameCC: 'token_pay_rental_boat_add_ons',
        setRentalBoatAddOns: 'set_rental_boat_add_ons',
        getOffDaysList: 'get_off_days_list',
        setOffDaysList: 'set_off_day',
        unsetOffDay: 'unset_off_day',
        rentalCompletePreCheck: 'rental_complete_precheck',
        removeRentalBoatPayedItem: 'remove_rental_boat_payed_item',
        addRentalBoatPayedItem: 'add_rental_boat_payed_item',
        closeRentalBoatPayments: 'close_rental_boat_payments',
        getCouponsList: 'get_coupons_list',
        getDiscountsList: 'get_discounts_list',
        addCoupon: 'add_coupon',
        updateCoupon: 'update_coupon_value',
        addDiscount: 'add_discount',
        updateDiscount: 'update_discount',
        revokeCoupon: 'revoke_coupon',
        unRevokeCoupon: 'unrevoke_coupon',
        getRentalMapInfo: 'get_rental_map_info',
        setNumOfAvailableBoats: 'set_num_of_available_boats',
        getRentalReportTypes: 'get_rental_report_types',
        adminSetVideoWatched: 'admin_set_rental_video_watched',
        sendSmsMessageToRentalOrderUser: 'send_sms_to_rental_order_user',

        /*| Users |*/
        getMoorageDashboard: 'admin_get_moorage_dashboard',
        getUserLicense: 'get_user_license',
        saveUserLicense: 'save_user_license',
        getUserBoatLicense: 'get_user_boating_license',
        saveUserBoatLicense: 'save_user_boating_license',
        getUserRentalBoatOrdersHistory: 'get_user_rental_boat_orders_history',

        /*| Users |*/
        getAppUsers: 'get_app_users',
        getBackOfficeUsers: 'get_backoffice_users',
        addBackOfficeUser: 'add_backoffice_user',
        updateBackOfficeUser: 'update_backoffice_user',
        getAppUserProfile: 'get_app_user_profile',
        setAppUserProfile: 'set_app_user_profile',
        addAppUserFromDm: 'add_app_user_from_dm',

        /*| Moorage |*/
        getMarinaSlips: 'get_marina_slips',
        getSlipInfoByName: 'get_slip_info_by_name',
        getMoorageMarinaOrders: 'get_moorage_marina_orders',
        getMoorageMarinaOrder: 'admin_get_moorage_order',
        getUserMoorageSlipsAndTxns: 'get_user_moorage_slips_and_txns',
        mooragePaySingleInvoice: 'moorage_pay_single_invoice',
        refundModalPayment: 'refund_moorage_payment',

        /*| User Creditcard |*/
        getUserCreditcards: 'get_user_creditcards',
        authorizeUserCreditcards: 'authorize_user_creditcards',
        setDefaultCc: 'set_default_creditcard',

        // Rental Boat
        getRentalBoatAvailableDays: 'get_rental_boat_available_days',
        changeRentalOrderDate: 'change_rental_order_date',
        getMonthAvailabilityCalendar: 'get_month_availability_calendar',
        getRestrictionMaps: 'get_restriction_maps',
        setActiveRestrictionMaps: 'set_active_restriction_map',
        getRestrictionMapsInfo: 'get_restriction_map_info',

        adminAuthorizeCreditCards: 'admin_authorize_creditcards',
        fluidpayAuthorizeToken: 'fluidpay_authorize_token',

        // Campaign
        getAllCampaign: 'Campaign/get_all',
        addCampaign: 'Campaign/add',
        getCampaign: 'Campaign/get',
        updateCampaign: 'Campaign/update',
        campaignGetDonationData: 'Campaign/get_donation_data',
        // Account
        getMyDetails: 'Account/get_my_details',
        updateMyAccount: 'Account/update_my_account',
        managedUserGetMyDetails: 'ManageUsers/get_my_details',
        managedUserUpdateMyAccount: 'ManageUsers/update_my_details',

        // Widgets
        getAllWidgets: 'Widget/get_all',
        widgetGet: 'Widget/get',
        viewerGetWidget: 'Viewer/get_widget',
        widgetSetStatus: 'Widget/set_status',
        widgetClone: 'Widget/clone',
        widgetGetDefaultStyle: 'Widget/get_default_style',
        widgetCreateDonationBox: 'Widget/create_donation_box',
        widgetUpdateDonationBox: 'Widget/update_donation_box',
        widgetCreateSupportRollBox: 'Widget/create_supporters_roll',
        widgetUpdateSupportRollBox: 'Widget/update_supporters_roll',
        widgetCreateGoalMeterBox: 'Widget/create_goal_meter',
        widgetUpdateGoalMeterBox: 'Widget/update_goal_meter',
        widgetDonationWithTilled: 'Donation/donate_with_tilled',
        tilledGetPaymentStatus: 'Donation/get_tilled_payment_status',
        tilledGetSubscriptionStatus: 'Donation/get_tilled_subscription_status',

        // Supporters
        supporterGetFilters: 'Supporter/get_filters',
        supporterGetAll: 'Supporter/get_all',
        supporterGetByEmail: 'Supporter/get_by_email',

        // Others
        getTimezoneList: 'General/get_time_zones',
    },
    isResponseSuccess(responseData) {
        return parseInt(responseData.rc) === 0;
    },
};

export default DibbleAPI;
